import { isIframe } from 'iframe-support'

export function getMainWindow() {
  if (isIframe()) {
    let mainWindow = window.parent
    try {
      // This may be blocked by browser's same origin policy
      if (typeof window.top.location.search !== 'undefined') {
        mainWindow = window.top
      }
    } finally {
      return mainWindow
    }
  }
  return window
}
